import { all } from 'redux-saga/effects';

import consultaAdicaoCategoriaSaga from './consultaAdicaoCategoria/saga';
import gerarRenachSaga from './gerarRenach/saga';

export const consultaAdicaoCategoria = consultaAdicaoCategoriaSaga;

export default all([consultaAdicaoCategoriaSaga, gerarRenachSaga]);
